import { Pill, Text } from "components/commons";
import { DateTime } from "enums";
import VIPRedemptionMethod from "enums/vip-redemption-method";
import VIPRedemptionStatus from "enums/vip-redemption-status";
import locale from "localization";
import moment from "moment";
import { formatAmount, formatNumber } from "utils";
import styles from "./redemption-history.module.scss";

const redemptionMethodLabel = {
  [VIPRedemptionMethod.LOCQPay]: locale.locqpayBalance,
  [VIPRedemptionMethod.Cash]: locale.cash,
  [VIPRedemptionMethod.PointsExpiry]: locale.pointsExpiry,
};

const statusLabel = {
  [VIPRedemptionStatus.Pending]: locale.pending,
  [VIPRedemptionStatus.Success]: locale.success,
  [VIPRedemptionStatus.Failed]: locale.failed,
  [VIPRedemptionStatus.Expired]: locale.expired,
};

export const mapDataToList = (redemption) => {
  const {
    vipRedemptionId,
    cashinId,
    points,
    amount,
    redemptionMethod,
    status,
    createdAt,
    updatedAt,
  } = redemption;

  return {
    vipRedemptionIdCashInId: (
      <div>
        <Text>{vipRedemptionId}</Text>
        <Text className={styles.subText}>{cashinId || "--"}</Text>
      </div>
    ),
    pointsRedeemedAmount: (
      <div>
        <Text>{formatNumber(points, 0)}</Text>
        <Text className={styles.subText}>{amount === null ? "--" : formatAmount(amount)}</Text>
      </div>
    ),
    dateCreatedFulfilledDate: (
      <div>
        <Text>{moment(createdAt).format(DateTime.E)}</Text>
        <Text className={styles.subText}>
          {updatedAt ? moment(updatedAt).format(DateTime.E) : "--"}
        </Text>
      </div>
    ),
    redemptionMethod: redemptionMethodLabel[redemptionMethod] || "--",
    status: (
      <Pill
        sky={status === VIPRedemptionStatus.Pending}
        grass={status === VIPRedemptionStatus.Success}
        deepRed={status === VIPRedemptionStatus.Failed}
        cement={status === VIPRedemptionStatus.Expired}
      >
        {statusLabel[status]}
      </Pill>
    ),
  };
};

export const mapFilterToRequest = (filterState) => {
  const { statuses, ...fs } = filterState;

  return {
    ...fs,
    statuses: (statuses.length ? statuses : Object.values(VIPRedemptionStatus)).join(","),
  };
};
